<template>
    <div class="pl-5 pb-5">
        <v-alert v-if="!runde.settings.startZeit && isOperator && !bewerbIsConfirmed" class="mr-5" icon="mdi-information" color="black" text style="font-size: 14px">
            Um die Bahnbelegung zu bearbeiten, klicke auf das Zahnrad rechts oben.
        </v-alert>
        <div :class="[{'d-flex flex-wrap align-baseline': $vuetify.breakpoint.smAndUp}, '']">
            <spiel-ko v-for="(spiel) in spiele" :key="runde.id + spiel.id"
                      :team-label="teamLabel"
                      :spiel="spiel"
                      :settings-spiel="runde?.settings.spiel"
                      :bewerb-is-confirmed="bewerbIsConfirmed"
                      :is-operator="isOperator"
                      @editTeam="editTeam"
                      @editSpielResult="editSpielResult"
                      @clearSpiel="confirmClearSpiel"/>
        </div>
    </div>
</template>

<script>
import SpielKo from "@/views/ergebnisdienst/meisterschaft/spiele/spielKo.vue";

export default {
    name: "meisterschaftRundeKo",
    components: {SpielKo},
    props: ['runde', 'dauerGeplant', 'teamLabel', 'landesverbandId', 'bewerbIsConfirmed'],
    computed: {
        spiele(){return this.runde.getSpiele(this.dauerGeplant)},
        isOperator(){ return this.$store.getters["user/isMeisterschaftOperator"](this.landesverbandId)},
    },
    methods: {
        refresh(){
            this.$emit('refreshBewerb')
        },
        editTeam(params){
            this.$emit('editTeam', params);
        },
        editSpielResult(spiel){
            this.$emit('editSpielResult', {...spiel, rundenId: this.runde.id});
        },
        confirmClearSpiel(spiel){
            this.$emit('confirmClearSpiel', {spiel, rundenId: this.runde.id});
        }
    },
}
</script>

<style scoped>

</style>